export const Status = {
    CreatedStatus: { id: 1, name: "Created", memberName: "Created" },
    ReceivedStatus: { id: 2, name: "Received", memberName: "Received" },
    ProcessingStatus: { id: 3, name: "Processing", memberName: "Received" },
    ReviewStatus: { id: 4, name: "Review", memberName: "Received" },
    CompletedStatus: { id: 5, name: "Completed", memberName: "Received" },
    EmailSentStatus: { id: 6, name: "Email Sent", memberName: "Report Received" },
    ErrorStatus: { id: 7, name: "Error", memberName: "Error" }
}

export enum KitStatus {
    Created = 1,
    Received = 2,
    Processing = 3,
    Review = 4,
    Completed = 5,
    EmailSent = 6,
    Error = 7,
}

export const kitStatuses = [
    Status.CreatedStatus,
    Status.ReceivedStatus,
    Status.ProcessingStatus,
    Status.ReviewStatus,
    Status.CompletedStatus,
    Status.EmailSentStatus,
    Status.ErrorStatus,
]

export type KitTracking = {
    Id: number,
    SubmittedKitId: number,
    KitStatusId: number,
}

export function apiModelToKitTracking(apiModel: any) {
    return {
        Id: apiModel.id,
        SubmittedKitId: apiModel.submittedKitId,
        KitStatusId: apiModel.kitStatusId,
    } as KitTracking;
}

export const blankKitTracking = {
    Id: 0,
    SubmittedKitId: 0,
    KitStatusId: 0,
} as KitTracking;